import script from "./UniversalTextField.vue?vue&type=script&setup=true&lang=js"
export * from "./UniversalTextField.vue?vue&type=script&setup=true&lang=js"

import "./UniversalTextField.vue?vue&type=style&index=0&id=e8407152&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-e8407152"]])

export default __exports__